<div class="item-container">
    <div class="item-header">
        <h5 class="text-center" *ngIf="!packId">{{ "Add" | translate }} {{"Pack"|translate}}</h5>
        <h5 class="text-center" *ngIf="packId">{{ "Edit" | translate }} {{"Pack"|translate}}</h5>
        <div class="edit-icons" (click)="onCancel()">
            <i class="material-icons">close</i>
        </div>
    </div>
    <div class="doc-cont modal-max item-content" style="position: relative;">
        <h6 class="mt-3 mt-xl-5">Document Packs</h6>
        <p class="mt-2">Manage which documents will be required to add to employees. You can create different packs of
            documents for different groups of users</p>
        <div class="doc-pack mt-4" *ngFor="let item of documentPackArr;let i=index">
            <div class="d-flex flex-wrap flex-md-nowrap">
                <div class="profile-img "></div>
                <div class="flex-grow-1 l-c">
                    <div class="flex-grow-1 d-flex align-items-center ms-3  ">
                        <input type="text" class="form-control input-c" [(ngModel)]="item.name"
                            style="border-bottom: 1px solid var(--border-color) !important"
                            placeholder="Enter Group Name">
                        <div class="action-icon  del-icon ms-2" (click)="onDeleteItem(i)" *ngIf="!packId">
                            <i class="material-icons">delete</i>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6 flex-wrap " *ngFor="let val of item.doc_arr;let j=index">
                            <div class="d-flex doc-box mb-0 flex-wrap align-items-center">
                                <h6 class="mb-0 flex-grow-1">{{val.d_n}}</h6>
                                <div class="d-flex">
                                    <div class="action-icon green-bg me-2" matTooltip="Visible to the user in app"  *ngIf="val.v_u=='1'">
                                        <i class="material-icons">remove_red_eye</i>
                                    </div>
                                    <div class="action-icon edit-icon me-2" (click)="onAddEditDocument(i,j,val)">
                                        <i class="material-icons">mode_edit</i>
                                    </div>
                                    <div style="position: relative;"  (click)="deleteItem(i,j,val.id)" >
                                        <div class="action-icon me-2 del-icon" >
                                            <i class="material-icons">delete</i>
                                        </div>
                                 </div>
                                    <ng-template #popoverContenst>
                                        <div class="pop-cont" style="height:130px;width:160px;">
                                            <label for="" class="text-center" style="line-height: 19px;"> Are you sure
                                                you want to delete this content ?</label>

                                            <div class="d-flex justify-content-center">
                                                <button class="btn btn-danger btn-no">Delete</button>
                                            </div>
                                        </div>
                                    </ng-template>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex align-items-center mt-3 text-cont ms-3 cursor-pointer"
                        (click)="onAddEditDocument(i,'','')"> <i class="material-icons me-2 ">add</i> Add Document</div>
                </div>
            </div>
            <mat-error *ngIf="item.isErr" class="text-center">Please insert group name and at least one document
            </mat-error>
        </div>
        <div class="add-section d-flex align-items-center justify-content-center text-cont mt-3 mt-lg-4 mb-3 mb-xl-5"
            *ngIf="!packId" (click)="onAddDocumentPack()"> <i class="material-icons me-2 add-obj">add</i> Add Document
            Pack
        </div>
    </div>
    <div class="row  bottom-border">
        <div class="col-md-6"></div>
        <div class="col-md-6 d-flex justify-content-end align-items-center  pb-xxl-2">
            <button type="button" class="btn auth-form-btn btn-outline-primary mt-3  me-3 align-items-center" mat-dialog-close>{{"Cancel"
                |translate}}</button>
            <button mat-raised-button color="primary" class="auth-form-btn mt-3 " type="submit"
                (click)="onSaveDocumentPack()">{{"Save"|translate}}</button>
        </div>
    </div>
</div>
<app-loading-spinner></app-loading-spinner>